var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXmarkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.801,
    height: 21.801,
    viewBox: "0 0 21.801 21.801",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16799",
    "data-name": "Path 16799",
    d: "M35.095,14.835l-1.414-1.414-9.486,9.486-9.486-9.486-1.414,1.414,9.486,9.486-9.486,9.487,1.414,1.414,9.486-9.487,9.486,9.487,1.414-1.414-9.486-9.487Z",
    transform: "translate(-13.294 -13.421)",
    fill: "#ededed"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXmarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Xmark_icon.425432db1467e021cf20f2d91f27cbbb.svg";